import { methodColor, type Method } from '@/lib/tokens';

export default function MethodBadge({ method, size = 'sm' }: { method: Method; size?: 'xs' | 'sm' | 'md' }) {
    const color = methodColor(method);
    const fontSize = size === 'xs' ? 9 : size === 'sm' ? 10 : 11;
    const padding = size === 'xs' ? '2px 5px' : '3px 6px';
    return (
        <span
            className="inline-block font-bold tracking-wide uppercase rounded"
            style={{
                fontSize,
                padding,
                color,
                backgroundColor: `${color}1a`,
                border: `1px solid ${color}33`,
                lineHeight: 1.4,
                minWidth: size === 'xs' ? 28 : 36,
                textAlign: 'center',
            }}
        >
            {method}
        </span>
    );
}
